import { AccountService } from '../../service/AccountService';
export class LoginService extends AccountService {
  static getTenant(tenantName: string): Promise<any> {
    return this.axios.get(`api/abp/multi-tenancy/tenants/by-name/${tenantName}`).then(res => res.data);
  }

  static login(tenantId: string, username: string, password: string, rememberMe: boolean): Promise<any> {

    return this.axios.post(`connect/token`, {
      grant_type: 'password', client_id: 'Management_App', scope: 'offline_access Management', issuer: 'https://localhost:44322',
      username, password, rememberMe
    }, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        // __tenant: tenantId
      }
    }).then(res => res.data);
  }

  static logout(): Promise<any> {
    return this.axios.get(`${this.entity}/logout`).then(res => res.data);
  }

  static forgotPassword(email: string, taxCode: string): Promise<any> {
    return this.axios.post(`api/app/my-account/send-reset-password`, { email, taxCode }).then(res => res.data);
  }

}
